module.exports = __webpack_public_path__ + "img/cr.svg";